"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_STATUS = void 0;
exports.BUILD_STATUS = {
    NEW: 'NEW',
    UPDATE_DEPENDENCIES: 'UPDATE_DEPENDENCIES',
    DOWNLOAD_ASSETS: 'DOWNLOAD_ASSETS',
    UPDATE_COMPONENTS: 'UPDATE_COMPONENTS',
    UPDATE_PAGES: 'UPDATE_PAGES',
    BUILD: 'BUILD',
    UPLOAD_FILES: 'UPLOAD_FILES',
    DONE: 'DONE',
    ERROR: 'ERROR'
};
//# sourceMappingURL=buildStatus.js.map